ALKMaps.Popup.AddressPopup = ALKMaps.Class(ALKMaps.Popup.SimplePopup, {
  initialize: function (id, lonlat, contentSize, contentHTML, offset, closeBox, closeCallback, cancelCallback, saveCallback) {
    // this.id = ALKMaps.Util.createUniqueID(id + "_");
    if (cancelCallback) {
      this.cancelCallback = cancelCallback;
    }
    if (saveCallback) {
      this.saveCallback = saveCallback;
    }

    ALKMaps.Popup.SimplePopup.prototype.initialize.apply(this, arguments);
    var clickPopup = function (e) {
      if (e.target.id === "btnPopupCancel") { // Hacking code. Need hard coded value.
        this.cancelCallback(this);
        ALKMaps.Event.stop(e);
      } else if (e.target.id === "btnPopupSave") {
        this.saveCallback(this);
        ALKMaps.Event.stop(e);
      }
    };    
    ALKMaps.Event.observe(this.contentDiv, "touchend",
      ALKMaps.Function.bindAsEventListener(clickPopup, this));
    ALKMaps.Event.observe(this.contentDiv, "click",
      ALKMaps.Function.bindAsEventListener(clickPopup, this));
  },

  cancelCallback: function (e) {
    // console.log(e);
  },

  saveCallback: function (e) {
    // alert('save');
  },

  destroy: function () {
    ALKMaps.Event.stopObservingElement(this.contentDiv);
    ALKMaps.Popup.SimplePopup.prototype.destroy.apply(this, arguments);
  },

  CLASS_NAME: "ALKMaps.Popup.AddressPopup"
});


// WEBPACK FOOTER //
// ./app/alkmapsExtension/popupAddress.js